// Generated by scripts/build-ui-icons.mjs.
export { Hammer as default } from "../ui/glyphs-4";
